const uniqueSorted = (values) =>
  Array.from(new Set(values.filter((v) => v !== null && v !== undefined && v !== ''))).sort();

export const getFilterOptions = (vehicles) => ({
  makes: uniqueSorted(vehicles.map((v) => v.make)),
  bodyTypes: uniqueSorted(vehicles.map((v) => v.bodyType)),
  years: uniqueSorted(vehicles.map((v) => v.year))
    .map(String)
    .sort((a, b) => b.localeCompare(a)),
  priceRanges: [
    { value: '0-10000', label: 'Under £10,000' },
    { value: '10000-20000', label: '£10,000 - £20,000' },
    { value: '20000-40000', label: '£20,000 - £40,000' },
    { value: '40000-70000', label: '£40,000 - £70,000' },
    { value: '70000-100000', label: '£70,000 - £100,000' },
    { value: '100000+', label: '£100,000+' },
  ],
  transmissions: uniqueSorted(vehicles.map((v) => v.transmission)),
  fuelTypes: uniqueSorted(vehicles.map((v) => v.fuel)),
});

export const filterVehicles = (vehicles, filters) =>
  vehicles.filter((vehicle) => {
    if (filters.make && vehicle.make !== filters.make) return false;
    if (filters.bodyType && vehicle.bodyType !== filters.bodyType) return false;
    if (filters.year && String(vehicle.year) !== String(filters.year)) return false;
    if (filters.transmission && vehicle.transmission !== filters.transmission) return false;
    if (filters.fuel && vehicle.fuel !== filters.fuel) return false;

    if (filters.price) {
      const [min, max] = filters.price.split('-').map((p) => p.replace('+', ''));
      const minPrice = parseInt(min, 10) || 0;
      const maxPrice = max ? parseInt(max, 10) : Infinity;
      if (vehicle.price < minPrice || vehicle.price > maxPrice) return false;
    }

    return true;
  });

export const getVehicleById = (vehicles, id) => vehicles.find((v) => v.id === id);
